/**
 * Status constants for S&D 844 pipeline rows.
 *
 * Lifecycle: pending → staged → processing → sent
 *            pending → staged_internal (internal contract prefixes)
 *            any (except sent/no_claim) → no_claim → pending (unmark)
 */
export const E844PipelineRowStatus = {
  PENDING: "pending",
  STAGED: "staged",
  STAGED_INTERNAL: "staged_internal",
  PROCESSING: "processing",
  SENT: "sent",
  NO_CLAIM: "no_claim",
} as const;

export type E844PipelineRowStatusType =
  (typeof E844PipelineRowStatus)[keyof typeof E844PipelineRowStatus];
